import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  SimpleLoading,
  DescriptionDialogBoxTemplatePure,
  ButtonTemplatePure,
} from "../../pures";
import "./dialog-template.css";

/* === Dialog component form signer === */
const DialogTemplatePure = (props) => {
  const {
    loadingComponent,
    cancel,
    saveError,
    title,
    description,
    handleSubmitProfile,
    saveBtn,
    canelBtn,
    profiles,
    userId,
    userName,
    children,
  } = props;

  let dialogCollaboratorWidth = loadingComponent ? 590 : 600;
  let dialogCollaboratorHeight = loadingComponent ? 430 : 560;

  return (
    // <div style={props.showErrorDomain === true ? { display: 'none' } : null}>
    <Dialog
      width={dialogCollaboratorWidth}
      height={dialogCollaboratorHeight}
      className="dialogTemplatePure-container"
      title={title}
      onClose={cancel}
    >
      {loadingComponent && (
        <div>
          <SimpleLoading />
        </div>
      )}

      {!saveError && !loadingComponent && (
        <form>
          <div className="dialogTemplatePure-body-dialog">
            {description && <DescriptionDialogBoxTemplatePure description={description} />}
            {children}
            <div
              item="true"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="dialogTemplatePure-btns-container"
            >
              <ButtonTemplatePure nameBtn={canelBtn} onClick={cancel} />
              <ButtonTemplatePure
                type="submit"
                primary={true}
                nameBtn={saveBtn}
                onClick={(e) => handleSubmitProfile(e)}
              // disabled={props.disableUserButton}
              />
            </div>
          </div>
        </form>
      )}
    </Dialog>
    // </div>
  );
};

export { DialogTemplatePure as default };
